import { collectionFilters } from '../../../api/collections';

export enum CollectionFilterTab {
  All = 'All',
  Marketplace = 'Marketplace',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Pending = 'Pending',
  Draft = 'Draft',
}

export const collectionFilterTabToApiFilters: Record<
  CollectionFilterTab,
  collectionFilters | undefined
> = {
  [CollectionFilterTab.All]: undefined,
  [CollectionFilterTab.Marketplace]: { marketplace: true },
  [CollectionFilterTab.Approved]: {
    approved: true,
  },
  [CollectionFilterTab.Rejected]: { rejected: true },
  [CollectionFilterTab.Pending]: { pending: true },
  [CollectionFilterTab.Draft]: { draft: true },
};

export const collectionFilterTabs = Object.values(CollectionFilterTab);
